import { For, JSX, JSXElement, mergeProps, Show } from 'solid-js';
import Link from '../Link';
import { ChevronRight } from 'lucide-solid';
import { twMerge } from 'tailwind-merge';

export type BreadcrumbProps = {
  customSeparator?: JSXElement;
  breadcrumbList: Array<BreadcrumbItem>;
  class?: string;
  listClass?: string;
  showSeparator?: boolean;
};

export type BreadcrumbItem = {
  label: JSXElement;
  href?: string;
  class?: string;
  onClick?:
    | JSX.EventHandlerUnion<
        HTMLAnchorElement,
        MouseEvent,
        JSX.EventHandler<HTMLAnchorElement, MouseEvent>
      >
    | undefined;
  removeLink?: boolean;
};

export const Breadcrumb = (props: BreadcrumbProps) => {
  const merged = mergeProps({ showSeparator: true }, props);

  return (
    <nav
      aria-label="Breadcrumb"
      class={merged?.class}
    >
      <ol
        class={twMerge(
          `flex items-center text-fg-subtle text-sm ${merged?.listClass ?? ''}`
        )}
      >
        <For each={merged.breadcrumbList}>
          {(item, index) => {
            const isLastCrumb = index() === merged.breadcrumbList.length - 1;

            return (
              <li class={twMerge('flex items-center', item?.class ?? '')}>
                <Show
                  when={!isLastCrumb}
                  fallback={<div>{item.label}</div>}
                >
                  <Show
                    when={!item?.removeLink}
                    fallback={item.label}
                  >
                    <Link
                      href={item?.href ?? '#'}
                      class={`mr-2 hover:text-fg-default`}
                      onClick={item?.onClick}
                    >
                      {item.label}
                    </Link>
                  </Show>
                  <Show when={merged.showSeparator}>
                    <Show
                      when={merged?.customSeparator}
                      fallback={
                        <ChevronRight
                          width={24}
                          strokeWidth={1}
                          class={`mr-2`}
                        />
                      }
                    >
                      {merged.customSeparator}
                    </Show>
                  </Show>
                </Show>
              </li>
            );
          }}
        </For>
      </ol>
    </nav>
  );
};
